import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Chip } from '../../../components/chips/Chip';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import styles from './search_except_expressions.module.scss';
import { Hyperlink } from '../../../components/Hyperlink';
import { PopoverFactoryRenderer } from '../../../components/popovers/PopoverFactoryRenderer';
import { Paper } from '../../../components/paper/Paper';

type Props = {
  exceptExpressions: Array<string>;
  onExpressionsUpdate?: Function;
};

export const SearchExceptExpressions: FC<Props> = ({
  exceptExpressions,
  onExpressionsUpdate,
}) => {
  useEffect(() => {
    if (onExpressionsUpdate) {
      onExpressionsUpdate();
    }
  }, [exceptExpressions.length]);

  if (!exceptExpressions.length) {
    return null;
  }

  const displayPopover = () => {
    return (
      <Paper className={styles.popover}>
        <FormattedMessage
          id="search/components/SearchExceptExpressions.tsx/2"
          values={{
            a: (msg: string) => (
              <Hyperlink
                className={styles.link}
                target="_blank"
                href="http://help.doctrine.fr/fr/articles/3607902-utilisez-les-filtres-avances-pour-trouver-des-reponses-inedites"
              >
                {msg}
              </Hyperlink>
            ),
          }}
        />
      </Paper>
    );
  };

  return (
    <Chip color="secondary" className={styles.container}>
      <FormattedMessage id="search/components/SearchExceptExpressions.tsx/1" />
      {exceptExpressions.join(', ')}
      <PopoverFactoryRenderer renderTemplate={displayPopover}>
        <MaterialIcon
          className={styles.icon}
          name="info_outline"
          data-doctrine-popover
        />
      </PopoverFactoryRenderer>
    </Chip>
  );
};
